import { api_fetch } from './api'

export interface AppConfig {
  version: string
  environment: string
  recaptcha_site_key: string
  auth_mode: 'local-bypass' | 'recaptcha'
  origin_validation_enabled: boolean
  maps_embed_api_key: string
  maps_embed_enabled: boolean
  driver_review_direct_enabled: boolean
  vapid_public_key: string
  google_play_app_url: string
  apple_app_store_url: string
}

export async function fetch_config(): Promise<AppConfig> {
  const res = await api_fetch('/api/config')
  if (!res.ok) throw new Error(`Failed to fetch config: ${res.status}`)
  return (await res.json()) as AppConfig
}
